import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { Loader, SocialSecurityFormTeaser, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { useFetchingUserDocuments } from "Bands/utils";
import { GridContainer } from "shared/styles";

const formCopy = copy.userSocialSecurityForm;

export const SocialSecurityForms: FC = () => {
  const { socialSecurityForms } = useFullUserProfileContext();

  const { fetchingSocialSecurityForms } = useFetchingUserDocuments();

  if (fetchingSocialSecurityForms) return <Loader />;
  if (!socialSecurityForms?.length) return null;

  return (
    <Spacer size="m">
      <Title title={formCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {socialSecurityForms?.map(form => (
          <SocialSecurityFormTeaser key={form.id} {...form} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
